import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'count': 0,
  'list': [],
  'limit': 20,
  'offset': 0,
  'downloading': false,
  'pncListUrl': '',
};

export const allPartNumberCodes = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.GET_PNC_INFO_REQUEST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.GET_PNC_INFO_SUCCESS]: (state, action) => ({
      ...state,
      'loading': false,
      'count': action.response.count,
      'list': action.response.data,
    }),
    [ActionTypes.CLEAR_PNC_LIST]: (state, action) => ({
      ...state,
      ...INITIAL_STATE,
    }),
    [ActionTypes.GET_PNC_INFO_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'count': 0,
      'list': [],
    }),
    [ActionTypes.CHANGE_PART_NUMBER_CODE_INFORMATION_PAGE]: (state, action) => ({
      ...state,
      'offset': action.payload,
    }),
    [ActionTypes.CHANGE_PART_NUMBER_CODE_INFORMATION_PAGE_SIZE]: (state, action) => ({
      ...state,
      'limit': action.payload,
    }),
    [ActionTypes.DOWNLOAD_LIST_REQUEST]: (state, action) => ({
      ...state,
      'downloading': true,
    }),
    [ActionTypes.DOWNLOAD_LIST_SUCCESS]: (state, action) => ({
      ...state,
      'downloading': false,
      'pncListUrl': action.response.data,
    }),
    [ActionTypes.CLEAR_PNC_LIST_URL]: (state, action) => ({
      ...state,
      'pncListUrl': '',
    }),
  })(state, action);
};
